import React, { useState } from 'react';
import cx from 'classnames';
import { createPortal } from 'react-dom';

import FullPageOverlay from '@marketing/components/full_page_overlay';
import SectionHeader from '@marketing/components/section_header';

import FocusedLessonCard from './assets/focused_lesson_card.png';
import LessonCardsBg from './assets/lesson_cards_bg.png';
import MikeHeadshot from './assets/mike_headshot.png';
import PlayIcon from './assets/play_icon.svg';
import VideoThumbnail from './assets/video_thumbnail.png';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

const VideoBasedLearningSection: React.FC<{}> = (props) => {
  const [displayVideoPlayer, setDisplayVideoPlayer] = useState<boolean>(false);

  return (
    <div style={{ position: 'relative' }}>
      <div className="d-flex flex-column gap-l">
        <SectionHeader
          subtitle="Magoosh lessons are shaped by student feedback to deliver material in the way you learn best."
          supertitle="Video based learning"
          supertitleIcon={PlayIcon}
          title="200+ curated lessons covering every topic"
        />

        <div className={styles.lessonCardsContainer} style={{ position: 'relative' }}>
          <div className="hidden-xs hidden-sm" style={{ position: 'absolute' }}>
            <img
              alt="Array of different types of lesson on Math and Reading & Writing"
              loading="lazy"
              src={LessonCardsBg}
            />
          </div>

          <div
            className={cx(styles.videoThumbnailContainer, 'd-flex flex-column gap-s')}
            style={{ position: 'relative', zIndex: 1 }}
          >
            <div>
              <img
                alt="Thumbnail of lesson video with a play button"
                height="200px"
                loading="lazy"
                onClick={() => setDisplayVideoPlayer(true)}
                src={VideoThumbnail}
                style={{
                  border: '1px solid #BEC7CC',
                  borderRadius: 16,
                  boxShadow: '0 49px 29px rgba(0, 0, 0, 0.05), 0 22px 22px rgba(0, 0, 0, 0.08), 0 5px 12px rgba(0, 0, 0, 0.09)',
                  cursor: 'pointer',
                }}
                width="347px"
              />
            </div>

            <div>
              <img
                alt="Lesson snippet that is related to the full lesson video"
                height="173px"
                loading="lazy"
                src={FocusedLessonCard}
                width="399px"
              />
            </div>
          </div>
        </div>
      </div>

      {
        displayVideoPlayer && (
          createPortal(
            <>
              <div
                className={styles.pageOverlay}
                onClick={() => setDisplayVideoPlayer(false)}
              />

              <div className={cx(marketingStyles.purpleNoiseBg, styles.videoPlayerContainer)}>
                <div className={cx(styles.videoPlayerWrapper, 'd-flex flex-column')}>
                  <div
                    className="align-items-center bg-white d-flex gap-s"
                    style={{ borderRadius: '12px 12px 0 0', padding: 10 }}
                  >
                    <img alt="Mike McGarry headshot" height="30px" src={MikeHeadshot} width="30px" />

                    <div className="flex-1 small"><strong>Mike McGarry</strong></div>

                    <div>
                      <a className="small text-body" onClick={() => setDisplayVideoPlayer(false)}>
                        close video
                      </a>
                    </div>
                  </div>

                  <video autoPlay className={styles.videoPlayer} controls style={{ borderRadius: '0 0 12px 12px' }}>
                    <source src="https://d296n67kxwq0ge.cloudfront.net/audio_video/e35625b67130b96a56ad21a4b334a73ac0c83737-video-20407/web.mp4" type="video/mp4" />
                    <source src="https://d296n67kxwq0ge.cloudfront.net/audio_video/e35625b67130b96a56ad21a4b334a73ac0c83737-video-20407/web_webm.webm" type="video/webm" />
                  </video>
                </div>
              </div>
            </>,
            document.body
          )
        )
      }
    </div>
  );
};

export default VideoBasedLearningSection;
